import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Button,
  Stack,
  Grid,
  Divider
} from '@mui/material';
import { CheckInApi, getBookingByUUID, getBookingByID } from '../../../service/booking_service';
import { MdDateRange, MdAccessTime, MdOutlinePersonOutline } from "react-icons/md";
import Cookies from 'js-cookie'
import LoginModal from '../../../component/loginpopup';
import "./style.css";
import TheWonderBlueLogo from '../../../images/thewonderblue_logo.png';

const BookingInfoView = () => {
  const { id } = useParams();
  const navigate = useNavigate()
  const token = Cookies.get('token');

  const [booking, setBooking] = useState({});
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  useEffect(() => {
    if (!id) {
      navigate('/404')
    }
    handleGetBookingByUUId()
  }, []);
  
  const handleGetBookingByUUId = async () => {
    try {
      const resUUID = await getBookingByUUID({ id: id });
      // console.log("Respone UUID", resUUID.data);
      const resid = await getBookingByID({ id: resUUID.data.booking_id });
      // console.log("Respone id", resid.data);
      setBooking(resid.data);
    } catch (error) {
      console.error(error);
      navigate('/404')
    }
  }

  const handleCheckIn = async () => {
    // If no token, open login modal
    if (!token) {
      setIsLoginModalOpen(true);
      return;
    }

    try {
      const data = booking
      data.id = data.booking_id
      const res = await CheckInApi(data, token);
      handleGetBookingByUUId()
      // Handle successful check-in (e.g., show success message, update booking status)
    } catch (error) {
      console.error(error);
      navigate('/404');
    }
  };

  const handleLogin = () => {
    // Automatically try to check in after successful login
    handleCheckIn();
  };

  const obfuscateName = (name) => {
    if (!name) return ""; // กรณีที่ไม่มีค่า
    return name.substring(0, 3) + " _".repeat(name.length - 3);
  };

  const bookingFormatDate = (dateStr) => {
    if (!dateStr) return ""; // ตรวจสอบว่า dateStr มีค่าหรือไม่

    // แยกวันที่ (DD), เดือน (MM), และปี (YYYY) ออกจาก dateStr
    const [day, month, year] = dateStr.split("-");

    // ชื่อเดือนภาษาอังกฤษแบบย่อ
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // คืนค่าเป็นรูปแบบ "30 Nov 2024"
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  };

  return (
    <Box
      sx={{
        margin: 'auto',
        maxWidth: 400,
        height: 'auto',
        padding: 2,
        background: 'linear-gradient(to bottom, #E3F2FD, #FFFFFF)',
        borderRadius: 4,
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column'
      }}
    >

      {/* Details Card */}
      <Card
        sx={{
          borderRadius: 4,
          boxShadow: 2,
          backgroundColor: 'white',
          py: 2,
          px: 2,
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >

        <img src={TheWonderBlueLogo} sx={{ marginTop: '50px' }} />

        <CardContent sx={{ flexGrow: 1 }}>

          <Divider sx={{marginY:'10px'}}/>

          {/* Location */}
          {/* <Card
            variant="outlined"
            sx={{
              textAlign: 'center',
              py: 1.5,
              border: '2px solid',
              borderRadius: 2,
              marginY: 2,
              borderColor:
                booking.status === 'เสร็จสิ้น' ? '#4CAF50' :
                  booking.status === 'รอให้บริการ' ? '#FFC107' : '#F44336',
              backgroundColor:
                booking.status === 'เสร็จสิ้น' ? '#E8F5E9' :
                  booking.status === 'รอให้บริการ' ? '#FFF3E0' : '#FFEBEE'
            }}
          >
            <Typography
              variant="body2"
              fontWeight="bold"
              color={
                booking.status === 'เสร็จสิ้น' ? 'success.main' :
                  booking.status === 'รอให้บริการ' ? 'warning.main' : 'error.main'
              }
            >
              {booking.status}

            </Typography>
          </Card> */}

          {/* Attributes Grid */}
          <Grid container spacing={2} justifyContent="center" mb={3}>
            <Grid item xs={4}>
              <Card
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  py: 1,

                  border: '2px solid #81D4FA',
                  borderRadius: 2
                }}
              >
                <MdDateRange
                  style={{ color: "#007AFF", fontSize: '24px', marginBottom: '8px' }}
                />
                <Typography variant="body2" fontWeight="medium">

                  {bookingFormatDate(booking.date)}
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Card
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  py: 1,

                  border: '2px solid #81D4FA',
                  borderRadius: 2
                }}
              >
                <MdAccessTime

                  style={{ color: "#007AFF", fontSize: '24px', marginBottom: '8px' }}
                />
                <Typography variant="body2" fontWeight="medium">
                  {booking.time}
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Card
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  py: 1,

                  border: '2px solid #81D4FA',
                  borderRadius: 2
                }}
              >
                <MdOutlinePersonOutline

                  style={{ color: "#007AFF", fontSize: '24px', marginBottom: '8px' }}
                />
                <Typography variant="body2" fontWeight="medium">
                  {booking.total_people}
                </Typography>
              </Card>
            </Grid>
          </Grid>

          {/* About Section */}
          <Box mb={3}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              sx={{ mb: 2 }}
            >
              รายละเอียดการจอง
            </Typography>

            <Stack spacing={2}>

              <Card
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Typography variant="body1" fontWeight="medium" color="text.secondary">
                  หมายเลขการจอง:
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  {booking.booking_id}
                </Typography>
              </Card>

              <Card
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Typography variant="body1" fontWeight="medium" color="text.secondary">
                  ชื่อผู้ใช้บริการ:
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  {booking.first_name} {obfuscateName(booking.last_name)}
                </Typography>
              </Card>

              <Card
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Typography variant="body1" fontWeight="medium" color="text.secondary">
                  ผู้ใหญ่:
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  {booking.adults} คน
                </Typography>
              </Card>

              <Card
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Typography variant="body1" fontWeight="medium" color="text.secondary">
                  เด็ก:
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  {booking.children} คน
                </Typography>
              </Card>

              {booking.status === "เสร็จสิ้น" && (
                <Card
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <Typography variant="body1" fontWeight="medium" color="text.secondary">
                    พนักงานที่ให้บริการ:
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.secondary"
                  >
                    {booking.update_by}
                  </Typography>
                </Card>
              )}
            </Stack>
          </Box>
        </CardContent>

        {true && (
          <Stack
            direction="row"
            spacing={2}
            sx={{
              mt: 'auto',
              pb: 2,
              px: 2
            }}
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ py: 1.5 }}
              disabled={booking.status === 'เสร็จสิ้น'}
              onClick={handleCheckIn}
            >
              {/* Check-In<div><small>(สำหรับเจ้าหน้าที่)</small></div> */}
              <Box>
                {/* <Typography>Check-In</Typography>
              <Typography><small>(สำหรับเจ้าหน้าที่)</small></Typography> */}
                <Typography>{booking.status !== "เสร็จสิ้น"  ?  "Check In" : "completed" }</Typography>
              </Box>
            </Button>
          </Stack>
        )}
      </Card>
      <LoginModal
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onLogin={handleLogin}
      />
    </Box>
  );
};

export default BookingInfoView;